import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const SuperAdminRoute = ({ children }) => {
  const { user, hasToken } = useSelector((state) => state.user);

  if (!user && hasToken) {
    return <></>;
  }

  return user && user.roles.includes("superadmin") ? (
    children
  ) : (
    <Navigate to='/' replace />
  );
};
export default SuperAdminRoute;
